import styled from "styled-components";

export const Wrapper = styled.div`
  width: 25%;
  height: 0.12rem;
  background: var(--Bleu);
  margin: var(--gap) auto;
`;
